function Footer() {
  return (
    <footer className="footer page__footer">
      <p className="subtitle footer__subtitle">© 2020 Mesto Russia</p>
    </footer>
  );
}

export default Footer;
